<template>
  <v-tooltip bottom>
    <v-btn
      slot="activator"
      class="orders-list-button"
      color="secondary"
      :loading="state === 'loading'"
      :disabled="disableSendButton"
      round
      @click.native="onClick"
    >
      <span>{{ sendButtonText }}</span>
      <v-icon v-if="!disableSendButton" dark right>send</v-icon>
    </v-btn>
    <span>{{ tooltipFirstRow }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'OrdersListButton',
  props: {
    dishes: {
      type: Array,
      default: () => [],
    },
    state: {
      type: String,
      required: true,
    },
    noSelectionMadeYet: Boolean,
    editable: Boolean,
  },
  computed: {
    dishesPrice() {
      const price = this
        .dishes
        .map(d => d.price)
        .reduce((a, b) => a + b, 0);

      return price;
    },
    disableSendButton() {
      const result = !this.editable || (this.state === 'done' && !this.noSelectionMadeYet);
      return result;
    },
    sendButtonText() {
      return `${this.dishesPrice.toFixed(2)} €`;
    },
    tooltipFirstRow() {
      let text = '';
      if ((this.state === 'dirty' || this.state === 'loading') && (!this.noSelectionMadeYet || this.dishes.length > 0)) {
        text = this.$t('mainComponent.saveButton');
      } else if (this.noSelectionMadeYet && this.editable) {
        text = this.$t('mainComponent.doNotOrder');
      } else {
        text = this.$t('mainComponent.orderSaved');
      }

      return text;
    },
  },
  methods: {
    onClick() {
      this.$emit('saveSelection');
    },
  },
};
</script>
